
















































import { Component, Prop, Vue } from "vue-property-decorator";
//  components
import DataIndicator from "@/components/dataQuality/DataOutliersTable/DataIndicator.vue";
//  types
import { CellData, IndicatorData } from "@/types/dataQuality/dataQualityTable";

@Component({
  components: {
    DataIndicator,
  },
})
export default class DataCell extends Vue {
  @Prop({ type: Object }) data!: CellData;

  //  @Getters
  get isIndicator(): boolean {
    if (!this.data) return false;
    return this.data.type === "dataIndicator" || this.data.type === "percentIndicator";
  }

  get isAutoRemove(): boolean {
    if (!this.data) return false;
    return this.data.type === "autoRemove";
  }

  get isActions(): boolean {
    if (!this.data) return false;
    return this.data.type === "settings";
  }

  get IndicatorData(): IndicatorData | undefined {
    if (!this.isIndicator) return;
    return {
      column: this.data.column,
      featureName: this.data.featureName,
      vesselId: this.data.vesselId,
      status: this.data.value,
      unmanagedCount: this.data.unmanagedCount,
      autoRemovedCount: this.data.autoRemovedCount,
      physicalBoundsCount: this.data.physicalBoundsCount,
      smartOutliersCount: this.data.smartOutliersCount,
      detectionTime: this.data.detectionTime,
      type: this.data.type,
      text: this.indicatorText,
      icon: this.indicatorIcon,
      align: this.data.align,
      link: null,
    };
  }

  get indicatorText(): string {
    if (this.data.column === "overallStatus") {
      if (this.data.value === 0) return "No Outliers";
      else if (Number(this.data.value) > 0 && Number(this.data.value) <= 10) return "Minor Outliers";
      else if (Number(this.data.value) > 10) return "Major Outliers";
      else return "N/A";
    } else {
      if (this.data.value && this.data.unmanagedCount !== undefined && this.data.unmanagedCount !== null) {
        return `${this.data.value} / ${this.data.unmanagedCount}`;
      }
      return this.data.value ? this.data.value.toString() : "";
    }
  }

  get indicatorIcon(): string {
    if (this.data.column === "overallStatus") {
      if (this.data.value === 0) return "mdi-database-check";
      else if (Number(this.data.value) > 0 && Number(this.data.value) <= 10) return "mdi-database-alert";
      else if (Number(this.data.value) > 10) return "mdi-database-alert";
      else return "mdi-close-circle";
    } else {
      return "mdi-close-circle";
    }
  }

  //  @Methods
  onAutoRemoveChange(enabled: boolean): void {
    this.$emit("autoRemoveChanged", { vesselId: this.data.vesselId, enabled });
  }

  settings() {
    this.$emit("onSettingsClick");
  }

  showOutliersInManageModal(indicatorData: IndicatorData): void {
    this.$emit("showOutliersInManageModal", indicatorData);
  }

  showTimeline(indicatorData: IndicatorData): void {
    this.$emit("showTimeline", indicatorData);
  }

  showVesselTimelines(): void {
    this.$emit("showVesselTimelines", {
      vesselId: this.data.vesselId,
      vesselName: this.getVesselName(),
    });
  }

  getVesselName(): string {
    // We need to get vessel name - this should be passed in the data or we need to find another way
    return `Vessel ${this.data.vesselId}`;
  }
}
